<template>
  <modal
    name="RelatorioIAModal"
    class="relatorio-modal"
    :height="'auto'"
    :width="'80%'"
    :adaptive="true"
    :scrollable="true"
    @opened="onModalOpened()"
  >
    <section class="relatorio-modal-wrapper">
      <h3 class="title">
        <span>{{ $t('relatorio_modal_title') }}</span>
        <span v-if="isReportDeprecated" class="report-status-badge deprecated">
          {{ $t('deprecated') }}
        </span>
        <span v-if="isReportEdited" class="report-status-badge deprecated">
          {{ $t('reportEdited') }}
        </span>
      </h3> 

      <section v-if="loading || loadingCardapio" class="loading-container">
        <p>{{ loadingCardapio ? $t('regerar_cardapio_gerando') : $t('relatorio_gerando') }}</p>
      </section>

      <main v-else class="relatorio-content">
        <section v-if="hasError" class="no-data-container error">
          <figure class="no-data-icon">
            <i class="fas fa-exclamation-triangle"></i>
          </figure>
          <section class="no-data-content">
            <h4>{{ $t('relatorio_erro_titulo') }}</h4>
            <p>{{ errorMessage }}</p>
          </section>
        </section>

        <section v-else-if="!hasData" class="no-data-container">
          <figure class="no-data-icon">
            <i class="fas fa-chart-line"></i>
          </figure>
          <section class="no-data-content">
            <h4>{{ $t('relatorio_sem_dados_titulo') }}</h4>
            <p>{{ $t('relatorio_sem_dados_mensagem') }}</p>
          </section>
        </section>

        <section v-else>
          <section class="tabs">
            <nav class="tabs-header" aria-label="Relatorio tabs">
              <button
                class="tab-button"
                :class="{ active: activeTab === 'resumo' }"
                @click="activeTab = 'resumo'"
              >
                {{ $t('relatorio_tab_resumo') }}
              </button>
              <button
                class="tab-button"
                :class="{ active: activeTab === 'conformidade' }"
                @click="activeTab = 'conformidade'"
              >
                {{ $t('relatorio_tab_conformidade') }}
              </button>
              <button
                class="tab-button"
                :class="{ active: activeTab === 'problemas' }"
                @click="activeTab = 'problemas'"
              >
                {{ $t('relatorio_tab_problemas') }}
              </button>
              <button
                class="tab-button"
                :class="{ active: activeTab === 'problemasIgnorados' }"
                @click="activeTab = 'problemasIgnorados'"
              >
                {{ $t('relatorio_tab_problemas_ignorados') }}
              </button>
            </nav>

            <section class="tabs-content">
              <!-- Aba Resumo -->
              <RelatorioSummaryTab
                v-if="activeTab === 'resumo'"
                :summary="summary"
                :metadata="metadata"
                :scoreBeforeAI="scoreBeforeAI"
                :showScoreComparison="showScoreComparison"
                :showSolverChanges="searchSolverCells"
                :showIAnotImprove="showIAnotImprove"
                :isReportDeprecated="isReportDeprecated"
                @clear-highlights-request="clearMenuHighlights"
                @highlight-solver="highlightSolverCells"
              />
              <!-- Aba Problemas -->
              <RelatorioIssuesTab
                v-if="activeTab === 'problemas'"
                :issues="relatorioData.issues || []"
                :problemaIgnorado=false
                :salvar-ok="salvarOk"
                :expandedIssues="expandedIssues"
                :expandedR2Entities="expandedR2Entities"
                :expandedR3Groups="expandedR3Groups"
                :expandedR8Groups="expandedR8Groups"
                @toggle-ignorado="toggleIgnorado"
                @toggle-ignorado-entity="toggleIgnoradoEntity"
                @toggle-ignorado-group="toggleIgnoradoGroup"
                @toggle-issue="handleToggleIssue"
                @toggle-r2-entity="handleToggleR2Entity"
                @toggle-r3-group="handleToggleR3Group"
                @toggle-r8-group="handleToggleR8Group"
                @tag-action="handleTagAction"
                @entity-action="handleEntityAction"
                @line-action="handleLineAction"
                @clear-highlights-request="clearMenuHighlights"
              />
              <!-- Aba Conformidade -->
              <RelatorioComplianceTab
                v-if="activeTab === 'conformidade'"
                :ruleCompliance="sortedRuleCompliance"
                :expandedRules="expandedRules"
                :compliantCount="compliantCount"
                :hasIssueForRule="hasIssueForRule"
                @toggle-rule="handleToggleRule"
                @open-issue-from-rule="openIssueFromRule"
              />
              <!-- Aba Problemas Ignorados -->
              <RelatorioIssuesTab
                v-if="activeTab === 'problemasIgnorados'"
                :issues="relatorioData.issues || []"
                :problemaIgnorado=true
                :salvar-ok="salvarOk"
                :expandedIssues="expandedIssues"
                :expandedR2Entities="expandedR2Entities"
                :expandedR3Groups="expandedR3Groups"
                :expandedR8Groups="expandedR8Groups"
                @toggle-ignorado="toggleIgnorado"
                @toggle-ignorado-entity="toggleIgnoradoEntity"
                @toggle-ignorado-group="toggleIgnoradoGroup"
                @toggle-issue="handleToggleIssue"
                @toggle-r2-entity="handleToggleR2Entity"
                @toggle-r3-group="handleToggleR3Group"
                @toggle-r8-group="handleToggleR8Group"
                @tag-action="handleTagAction"
                @entity-action="handleEntityAction"
                @line-action="handleLineAction"
                @clear-highlights-request="clearMenuHighlights"
              />
            </section>
          </section>
        </section>
      </main>

      <div class="modal-buttons">
        <p v-if="erroCardapio" class="cardapio-error-message">
          {{ erroCardapio }}
        </p>
        <div v-if="salvarOk" key="edit-mode" class="modal-buttons-row">
          <button 
            type="button" 
            class="button ghost" 
            @click="salvarProblemas"
            :disabled="salvando"
          >
            <span v-if="salvando" class="relatorio-sync-icon-wrapper is-spinning">
              <i class="fas fa-sync-alt relatorio-sync-icon"></i>
            </span>
            {{ salvando ? $t('salvando') : $t('Salvar') }}
          </button>
          <button 
            type="button" class="button ghost" @click="cancelarProblemas">
            {{ $t('Cancelar') }}
          </button>
        </div>
        <div v-else  key="default-mode" class="modal-buttons-row">
          <button 
            v-if="activeTab === 'problemas' || activeTab === 'problemasIgnorados'"
            type="button" class="button ghost" @click="editarProblemas">
            {{ $t('Editar') }}
          </button>
          <button type="button" class="button ghost" @click="fecharModal">
            <i class="fas fa-times"></i> {{ $t('Fechar') }}
          </button>
          <button
            type="button"
            class="button primary"
            @click="gerarRelatorio"
            :disabled="loading || loadingCardapio"
          >
            <span
              class="relatorio-sync-icon-wrapper"
              :class="{ 'is-spinning': loading }"
            >
              <i class="fas fa-sync-alt relatorio-sync-icon"></i>
            </span>
            {{ loading ? $t('relatorio_gerando_btn') : $t('relatorio_regerar') }}
          </button>
        </div>
      </div>
    </section>
  </modal>
</template>

<script>
import PlatesService from "@/application/services/Plates";
import RelatorioSummaryTab from "./relatorioIA/RelatorioSummaryTab.vue";
import RelatorioIssuesTab from "./relatorioIA/RelatorioIssuesTab.vue";
import RelatorioComplianceTab from "./relatorioIA/RelatorioComplianceTab.vue";
import {
  getIssueKey,
  getIssueRule,
  getVisibleEntities,
  getR3EntityActions,
  getR3GroupStorageKey,
  getR8GroupStorageKey,
  getR2EntityKey,
  buildHighlightTarget,
  dedupeTargets,
  getActionHighlightType,
  getActionButtonClass,
  getActionLabel,
  normalizeDateForMenu,
  normalizeSequencial,
  normalizePlateId,
  normalizeHighlightType,
  getEntityKey,
  getGroupKey
} from "./relatorioIA/relatorioIA.js";
import { t } from 'i18next';
import Util from "@/application/libs/util";

export default {
  name: "RelatorioIAModal",
  components: {
    RelatorioSummaryTab,
    RelatorioIssuesTab,
    RelatorioComplianceTab
  },
  props: {
    scenarioId: {
      type: [String, Number],
      default: null
    },
    scenarioVersion: {
      type: [String, Number],
      default: null
    },
    dataCatalog: {
      type: Object,
      default: null
    },
    autoCloseOnNavigate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      salvando: false,
      salvarOk: false,
      activeTab: 'resumo',
      relatorioData: null,
      errorMessage: null,
      expandedIssues: {},
      expandedR2Entities: {},
      expandedR3Groups: {},
      expandedR8Groups: {},
      expandedRules: {},
      contextLoadStateByKey: {},
      requestInFlight: null,
      requestInFlightSilent: false,
      promotedSilentRequestToVisible: false,
      reportStatus: null,
      reportCurrentScenarioVersion: null,
      reportScenarioVersion: null,
      loadingCardapio: false,
      erroCardapio: null
    };
  },
  computed: {
    sortedRuleCompliance() {
      if (!this.hasRuleCompliance) return [];
      const weight = {
        VIOLATED: 0,
        PARTIAL: 1,
        COMPLIANT: 2
      };
      return [...this.relatorioData.ruleCompliance].sort((a, b) => {
        const left = weight[a?.status] ?? 3;
        const right = weight[b?.status] ?? 3;
        if (left !== right) return left - right;
        return String(a?.ruleId || '').localeCompare(String(b?.ruleId || ''));
      });
    },
    currentScenarioContextKey() {
      const normalizedScenarioId = this.normalizeContextValue(this.scenarioId);
      if (!normalizedScenarioId) return null;
      const normalizedVersion = this.normalizeContextValue(this.scenarioVersion) || 'no-version';
      return `${normalizedScenarioId}::${normalizedVersion}`;
    },
    metadata() {
      return this.relatorioData?.metadata || {};
    },
    summary() {
      return this.relatorioData?.summary || {};
    },
    scoreBeforeAI() {
      return this.dataCatalog?.quality?.scoreBeforeAI ?? 0;
    },
    showScoreComparison() {
      return this.scoreBeforeAI > 0 && this.summary.overallScore > this.scoreBeforeAI;
    },
    searchSolverCells(){
      if (!this.dataCatalog?.tabela) return false;
      for (const dia of this.dataCatalog.tabela) {
        for (const coluna of (dia.colunas || [])) {
          if (coluna._meta && coluna._meta.id_origem === 'solver_IA') return true;
        }
      }
      return false;
    },
    showIAnotImprove() {
      return this.scoreBeforeAI < 0;
    },
    scoreDelta() {
      return this.summary.overallScore - this.scoreBeforeAI;
    },
    hasIssues() {
      return this.relatorioData?.issues?.length > 0;
    },
    hasRuleCompliance() {
      return this.relatorioData?.ruleCompliance?.length > 0;
    },
    hasData() {
      return !!this.relatorioData?.summary;
    },
    hasError() {
      return !!this.errorMessage;
    },
    isReportDeprecated() {
      return this.normalizeReportStatus(this.reportStatus) === 'DEPRECATED';
    },
    isReportEdited() {
      const root = this.relatorioData?.issues;

      if (!root) return false;

      const stack = [root];

      while (stack.length) {
        const current = stack.pop();

        if (!current || typeof current !== 'object') {
          continue;
        }

        // Encontrou o atributo
        if (
          Object.prototype.hasOwnProperty.call(current, 'idIgnorado') &&
          current.idIgnorado
        ) {
          return true;
        }

        // Percorre filhos
        if (Array.isArray(current)) {
          for (let i = current.length - 1; i >= 0; i--) {
            stack.push(current[i]);
          }
        } else {
          for (const key in current) {
            stack.push(current[key]);
          }
        }
      }

      return false;
    },
    compliantCount() {
      if (!this.hasRuleCompliance) return 0;
      return this.relatorioData.ruleCompliance.filter(rule => rule.status === 'COMPLIANT').length;
    }
  },
  watch: {
    currentScenarioContextKey: {
      immediate: true,
      handler(newKey, oldKey) {
        this.handleScenarioContextChange(newKey, oldKey);
      }
    }
  },
  methods: {
    // ====== Gerenciamento do modal ======
    gerarIdIgnorado() {
      return `ignorado-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    },
    toggleIgnorado({ issueKey, aba }) {
      const issue = this.relatorioData.issues.find(
        e => e.issueId == issueKey
      );
      if (!issue) return;

      const reativando = !!aba;
      const idIgnorado = reativando ? null : this.gerarIdIgnorado();

      this.$set(issue, 'idIgnorado', idIgnorado);
      (issue.affectedEntities || []).forEach((entity) => {
        this.$set(entity, 'idIgnorado', idIgnorado);
        (entity.groups || []).forEach((group) => {
          this.$set(group, 'idIgnorado', idIgnorado);
        });
      });
    },
    toggleIgnoradoEntity({ issueKey, entityKey, aba }) {
      const issueIndex = this.relatorioData.issues.findIndex(
        e => e.issueId == issueKey
      );
      if (issueIndex < 0) return;
      const issue = this.relatorioData.issues[issueIndex];
      const entities = issue.affectedEntities || [];
      const entityIndex = entities.findIndex(
        (entity, index) => getEntityKey(issue, issueIndex, entity, index) === entityKey
      );
      if (entityIndex < 0) return;
      const entity = entities[entityIndex];

      const reativando = !!aba;
      const idIgnorado = reativando ? null : this.gerarIdIgnorado();
      this.$set(entity, 'idIgnorado', idIgnorado);
      (entity.groups || []).forEach((group) => {
        this.$set(group, 'idIgnorado', idIgnorado);
      });
      this.verifyIssueIgnorado(issue, reativando);
    },
    verifyIssueIgnorado(issue, reativando) {
      if (reativando) {
        this.$set(issue, 'idIgnorado', null);
        return;
      }

      const todasIgnoradas = issue.affectedEntities.every(
        entidade => entidade.idIgnorado != null
      );

      if (todasIgnoradas) {
        this.$set(issue, 'idIgnorado', this.gerarIdIgnorado());
      }
    },
    toggleIgnoradoGroup({ issueKey, entityKey, groupKey, aba }) {
      const issueIndex = this.relatorioData.issues.findIndex(
        e => e.issueId == issueKey
      );
      if (issueIndex < 0) return;
      const issue = this.relatorioData.issues[issueIndex];
      const entities = issue.affectedEntities || [];
      const entityIndex = entities.findIndex(
        (entity, index) => getEntityKey(issue, issueIndex, entity, index) === entityKey
      );
      if (entityIndex < 0) return;
      const entity = entities[entityIndex];
      const groups = entity.groups || [];
      const groupIndex = groups.findIndex(
        (group, index) => getGroupKey(entity, group, index) === groupKey
      );
      if (groupIndex < 0) return;
      const group = groups[groupIndex];

      const reativando = !!aba;
      const idIgnorado = reativando ? null : this.gerarIdIgnorado();

      this.$set(group, 'idIgnorado', idIgnorado);
    },
    hasIssueForRule(ruleId) {
      return !!this.findIssueByRule(ruleId);
    },
    onModalOpened() {
      if (!this.scenarioId) {
        this.errorMessage = this.$t('relatorio_erro_sem_id');
        return;
      }
      if (this.isReportCompatibleWithCurrentScenario(this.relatorioData)) {
        this.emitReportStatusChange();
        return;
      }
      let contextState = this.getCurrentContextLoadState();
      if (contextState === 'loaded') {
        this.setCurrentContextLoadState('idle');
        contextState = 'idle';
      }
      if (contextState === 'idle' || contextState === 'error' || contextState === 'missing') {
        this.carregarRelatorio(false, { silent: false });
      }
    },
    fecharModal() {
      this.$modal.hide('RelatorioIAModal');
    },
    editarProblemas() {
      this.salvarOk = true;
      this._snapshotIgnorado = this._tirarSnapshotIgnorado();
    },
    cancelarProblemas() {
      if (this._snapshotIgnorado) {
        this._restaurarSnapshotIgnorado(this._snapshotIgnorado);
        this._snapshotIgnorado = null;
      }
      this.salvarOk = false;
    },
    async salvarProblemas() {
      this._snapshotIgnorado = null;
      this.recalcularSummary();
      await this.updateRelatorio();
      this.salvarOk = false;
    },
    recalcularSummary() {
      const issues = this.relatorioData.issues.filter(e=>e.idIgnorado == null);
      const result = this.contabilizarIssue(issues);
      this.relatorioData.summary.overallScore = result.score;
      this.relatorioData.summary.criticalIssuesCount = result.high;
      this.relatorioData.summary.mediumIssuesCount = result.medium;
      this.relatorioData.summary.lowIssuesCount = result.low;
      let qualityLevel = "POOR";
      if (result.score > 90) {
        qualityLevel = "EXCELLENT";
      } else if (result.score >= 70) {
        qualityLevel = "GOOD";
      } else if (result.score >= 45) {
        qualityLevel = "REGULAR";
      }
      this.relatorioData.summary.qualityLevel = qualityLevel;
    },
    contabilizarIssue(issues = []) {
      const SEVERITY_WEIGHT = {
        HIGH: 10,
        MEDIUM: 5,
        LOW: 1,
      };

      const contagem = issues.reduce(
        (acc, { severity }) => {
          if (severity in acc) {
            acc[severity]++;
          }
          return acc;
        },
        {
          HIGH: 0,
          MEDIUM: 0,
          LOW: 0,
        }
      );

      const score = Math.max(
        0,
        100 -
          contagem.HIGH * SEVERITY_WEIGHT.HIGH -
          contagem.MEDIUM * SEVERITY_WEIGHT.MEDIUM -
          contagem.LOW * SEVERITY_WEIGHT.LOW
      );

      return {
        score,
        high: contagem.HIGH,
        medium: contagem.MEDIUM,
        low: contagem.LOW,
      };
    },
    _tirarSnapshotIgnorado() {
      return (this.relatorioData?.issues || []).map((issue, issueIdx) => ({
        issueIdx,
        idIgnorado: issue.idIgnorado || null,
        entities: (issue.affectedEntities || []).map((entity, entityIdx) => ({
          entityIdx,
          idIgnorado: entity.idIgnorado || null,
          groups: (entity.groups || []).map((group, groupIdx) => ({
            groupIdx,
            idIgnorado: group.idIgnorado || null
          }))
        }))
      }));
    },
    _restaurarSnapshotIgnorado(snapshot) {
      const issues = this.relatorioData?.issues || [];
      snapshot.forEach(({ issueIdx, idIgnorado, entities }) => {
        const issue = issues[issueIdx];
        if (!issue) return;
        this.$set(issue, 'idIgnorado', idIgnorado);
        entities.forEach(({ entityIdx, idIgnorado: eId, groups }) => {
          const entity = (issue.affectedEntities || [])[entityIdx];
          if (!entity) return;
          this.$set(entity, 'idIgnorado', eId);
          groups.forEach(({ groupIdx, idIgnorado: gId }) => {
            const group = (entity.groups || [])[groupIdx];
            if (!group) return;
            this.$set(group, 'idIgnorado', gId);
          });
        });
      });
    },

    // ====== Contexto e estado ======
    normalizeContextValue(value) {
      if (value === null || value === undefined) return null;
      const normalized = String(value).trim();
      return normalized.length ? normalized : null;
    },
    normalizeReportStatus(status) {
      if (status === null || status === undefined) return null;
      const normalized = String(status).trim().toUpperCase();
      return normalized.length ? normalized : null;
    },
    getCurrentContextLoadState() {
      const key = this.currentScenarioContextKey;
      if (!key) return 'idle';
      return this.contextLoadStateByKey[key] || 'idle';
    },
    setCurrentContextLoadState(state) {
      const key = this.currentScenarioContextKey;
      if (!key) return;
      this.$set(this.contextLoadStateByKey, key, state);
    },
    getReportScenarioVersion(reportData = this.relatorioData) {
      return this.normalizeContextValue(reportData?.metadata?.scenario?.version)
        || this.normalizeContextValue(this.reportScenarioVersion);
    },
    getCurrentScenarioVersionForStatus() {
      return this.normalizeContextValue(this.reportCurrentScenarioVersion)
        || this.normalizeContextValue(this.scenarioVersion);
    },
    resolveReportStatus(relatorioRow = null, parsedReport = null) {
      const statusFromBackend = this.normalizeReportStatus(relatorioRow?.STATUSRELATORIOIA);
      if (statusFromBackend) {
        return statusFromBackend;
      }

      const reportVersionFromMetadata = this.normalizeContextValue(parsedReport?.metadata?.scenario?.version);
      const reportVersionFromRow = this.normalizeContextValue(relatorioRow?.VERSAORELATORIOIA);
      const reportVersion = reportVersionFromRow || reportVersionFromMetadata;
      const currentScenarioVersion = this.normalizeContextValue(relatorioRow?.VERSAOCENARIOATUAL)
        || this.normalizeContextValue(this.scenarioVersion);

      if (!parsedReport) {
        return 'MISSING';
      }
      if (!currentScenarioVersion || !reportVersion) {
        return 'CURRENT';
      }
      return reportVersion === currentScenarioVersion ? 'CURRENT' : 'DEPRECATED';
    },
    emitReportStatusChange() {
      this.$emit('report-status-change', {
        status: this.normalizeReportStatus(this.reportStatus),
        scenarioVersion: this.getCurrentScenarioVersionForStatus(),
        reportVersion: this.normalizeContextValue(this.reportScenarioVersion)
      });
    },
    setReportStatusState(status, options = {}) {
      const { scenarioVersion = null, reportVersion = null, emit = true } = options;
      this.reportStatus = this.normalizeReportStatus(status);
      this.reportCurrentScenarioVersion = this.normalizeContextValue(scenarioVersion);
      this.reportScenarioVersion = this.normalizeContextValue(reportVersion);
      if (emit) {
        this.emitReportStatusChange();
      }
    },
    isReportCompatibleWithCurrentScenario(reportData = this.relatorioData, reportStatus = this.reportStatus) {
      if (!reportData || !this.scenarioId) return false;
      const reportScenarioId = this.normalizeContextValue(reportData?.metadata?.scenario?.scenarioId);
      const currentScenarioId = this.normalizeContextValue(this.scenarioId);
      if (!currentScenarioId) return false;
      if (reportScenarioId && reportScenarioId !== currentScenarioId) return false;

      const currentScenarioVersion = this.normalizeContextValue(this.scenarioVersion);
      if (!currentScenarioVersion) return true;

      const reportScenarioVersion = this.getReportScenarioVersion(reportData);
      if (!reportScenarioVersion) return false;
      if (reportScenarioVersion === currentScenarioVersion) return true;

      const normalizedStatus = this.normalizeReportStatus(reportStatus);
      return normalizedStatus === 'DEPRECATED';
    },
    resetReportStateForNewContext() {
      this.relatorioData = null;
      this.errorMessage = null;
      this.activeTab = 'resumo';
      this.expandedIssues = {};
      this.expandedR2Entities = {};
      this.expandedR3Groups = {};
      this.expandedR8Groups = {};
      this.expandedRules = {};
      this.setReportStatusState(null, { emit: false });
    },
    handleScenarioContextChange(newKey, oldKey) {
      if (!newKey) {
        this.resetReportStateForNewContext();
        return;
      }
      if (newKey === oldKey) return;
      this.resetReportStateForNewContext();
    },

    // ====== Carregamento do relatório ======
    setLoadingState(value, options = {}) {
      const { emit = true } = options;
      this.loading = value;
      if (emit) {
        this.$emit('report-loading-change', value);
      }
    },
    getRelatorioRowsFromResponse(relatorioResponse) {
      if (!Array.isArray(relatorioResponse) || relatorioResponse.length === 0) {
        return [];
      }
      const [firstItem] = relatorioResponse;
      if (Array.isArray(firstItem)) {
        return firstItem;
      }
      if (firstItem && typeof firstItem === 'object') {
        return relatorioResponse;
      }
      if (typeof firstItem === 'string') {
        return [{ METADATAJSON: firstItem }];
      }
      return [];
    },
    async carregarRelatorio(regerar = false, options = {}) {
      const { silent = false } = options;
      if (!this.scenarioId) {
        if (!silent) {
          this.errorMessage = this.$t('relatorio_erro_sem_id');
        }
        this.setLoadingState(false, { emit: !silent });
        return;
      }

      if (this.requestInFlight) {
        if (!silent && this.requestInFlightSilent) {
          this.promotedSilentRequestToVisible = true;
          this.setLoadingState(true, { emit: true });
        }
        return this.requestInFlight;
      }

      if (!regerar) {
        if (this.isReportCompatibleWithCurrentScenario(this.relatorioData)) {
          this.setCurrentContextLoadState('loaded');
          return;
        }
        const contextState = this.getCurrentContextLoadState();
        if (contextState === 'missing' && silent) {
          return;
        }
      }

      this.requestInFlightSilent = !!silent;
      this.promotedSilentRequestToVisible = false;

      if (!silent) {
        this.setLoadingState(true, { emit: true });
      }
      if (!silent) {
        this.errorMessage = null;
      }
      const requestPromise = (async () => {
        const relatorioResponse = await PlatesService.verificaRelatorioIA(
          this.scenarioId,
          this.dataCatalog,
          regerar
        );
        const relatorioRows = this.getRelatorioRowsFromResponse(relatorioResponse);

        if (!relatorioRows || relatorioRows.length === 0) {
          this.setReportStatusState('MISSING', {
            scenarioVersion: this.scenarioVersion,
            reportVersion: null
          });
          if (regerar) {
            this.relatorioData = null;
          }
          this.setCurrentContextLoadState('missing');
          return;
        }

        const relatorioRow = relatorioRows[0] || {};
        const backendScenarioVersion = this.normalizeContextValue(relatorioRow?.VERSAOCENARIOATUAL)
          || this.normalizeContextValue(this.scenarioVersion);
        const backendReportVersion = this.normalizeContextValue(relatorioRow?.VERSAORELATORIOIA);
        const metadata = relatorioRow?.METADATAJSON;
        if (!metadata) {
          const statusWithoutMetadata = this.resolveReportStatus(relatorioRow, null);
          this.setReportStatusState(statusWithoutMetadata, {
            scenarioVersion: backendScenarioVersion,
            reportVersion: backendReportVersion
          });
          if (regerar) {
            this.relatorioData = null;
          }
          this.setCurrentContextLoadState('missing');
          return;
        }

        const parsedReport = JSON.parse(metadata);
        const resolvedStatus = this.resolveReportStatus(relatorioRow, parsedReport);
        this.setReportStatusState(resolvedStatus, {
          scenarioVersion: backendScenarioVersion,
          reportVersion: backendReportVersion || this.normalizeContextValue(parsedReport?.metadata?.scenario?.version)
        });

        if (!this.isReportCompatibleWithCurrentScenario(parsedReport, resolvedStatus)) {
          this.relatorioData = null;
          this.setCurrentContextLoadState('missing');
          return;
        }

        this.relatorioData = parsedReport;
        this.errorMessage = null;
        this.setCurrentContextLoadState('loaded');
      })().catch((error) => {
        console.error('Erro ao carregar relatório:', error);
        this.setCurrentContextLoadState('error');
        if (!silent) {
          this.errorMessage = error.message || this.$t('relatorio_erro_geral');
        }
      }).finally(() => {
        if (silent) {
          if (this.promotedSilentRequestToVisible) {
            this.setLoadingState(false, { emit: true });
          } else {
            this.loading = false;
          }
        } else {
          this.setLoadingState(false, { emit: true });
        }
        this.requestInFlight = null;
        this.requestInFlightSilent = false;
        this.promotedSilentRequestToVisible = false;
      });

      this.requestInFlight = requestPromise;
      return requestPromise;
    },
    async updateRelatorio() {
      if (this.salvando) return;
      this.salvando = true;
      this.errorMessage = null;

      try {
        await PlatesService.updateRelatorio(
          this.scenarioId,
          this.relatorioData
        );
      } catch (error) {
        console.error('Erro ao salvar relatório:', error);
        this.errorMessage = error.message || this.$t('relatorio_erro_salvar');
      } finally {
        this.salvando = false;
      }
    },
    gerarRelatorio() {
      const CONFIRM_GENERATE_IA_REPORT = t('confirm_generate_ia_report');
      Util.showConfirmationDialog(this.$modal, {
        onModalClose: function (confirmGenerateReport) {
          if (confirmGenerateReport) {
            this.clearMenuHighlights();
            this.carregarRelatorio(true, { silent: false });            
          }
        }.bind(this)
      }, CONFIRM_GENERATE_IA_REPORT);
    },

    // ====== Manipulação de estados de expansão ======
    clearIssueScopedExpansionState(issueId) {
      if (!issueId) return;
      if (this.expandedR2Entities[issueId] !== undefined) {
        this.$delete(this.expandedR2Entities, issueId);
      }
      const prefix = `${issueId}::`;
      Object.keys(this.expandedR3Groups).forEach((key) => {
        if (key.startsWith(prefix)) {
          this.$delete(this.expandedR3Groups, key);
        }
      });
      Object.keys(this.expandedR8Groups).forEach((key) => {
        if (key.startsWith(prefix)) {
          this.$delete(this.expandedR8Groups, key);
        }
      });
    },
    handleToggleIssue(payload) {
      const { issueId, issue, index } = payload;
      const current = !!this.expandedIssues[issueId];
      const next = !current;
      this.expandedIssues = {
        ...this.expandedIssues,
        [issueId]: next
      };

      if (next && issue) {
        this.clearIssueScopedExpansionState(issueId);
        this.$set(this.expandedR2Entities, issueId, null);
        return;
      }
      if (!next) {
        this.clearIssueScopedExpansionState(issueId);
      }
    },
    handleToggleR2Entity(payload) {
      const { issue, issueIndex, entity, entityIndex } = payload;
      const issueKey = getIssueKey(issue, issueIndex);
      const entityKey = getR2EntityKey(issue, issueIndex, entity, entityIndex);
      const current = this.expandedR2Entities[issueKey] || null;
      if (current === entityKey) {
        this.$set(this.expandedR2Entities, issueKey, null);
        return;
      }
      this.$set(this.expandedR2Entities, issueKey, entityKey);
    },
    handleToggleR3Group(payload) {
      const { issue, issueIndex, groupKey } = payload;
      const storageKey = getR3GroupStorageKey(issue, issueIndex, groupKey);
      this.$set(this.expandedR3Groups, storageKey, !this.expandedR3Groups[storageKey]);
    },
    handleToggleR8Group(payload) {
      const { issue, issueIndex, groupKey } = payload;
      const storageKey = getR8GroupStorageKey(issue, issueIndex, groupKey);
      this.$set(this.expandedR8Groups, storageKey, !this.expandedR8Groups[storageKey]);
    },
    handleToggleRule(payload) {
      const { ruleId, index } = payload;
      const key = `${ruleId}-${index}`;
      const current = !!this.expandedRules[key];
      this.expandedRules = {
        ...this.expandedRules,
        [key]: !current
      };
    },

    // ====== Ações de entidade ======
    handleTagAction({ tag, issue, entity }) {
      if (!tag || typeof tag !== 'object') return;
      if (Array.isArray(tag.highlightTargets) && tag.highlightTargets.length > 0) {
        const ruleId = getIssueRule(issue, entity);
        const emitted = this.emitHighlightTargets(tag.highlightTargets, ruleId, 'issue');
        if (emitted) return;
      }
      if (tag.action) {
        this.handleEntityAction({ action: tag.action, issue, entity });
      }
    },
    handleEntityAction({ action, issue, entity }) {
      if (!action) return;
      const ruleId = getIssueRule(issue, entity);
      if (Array.isArray(action.highlightTargets) && action.highlightTargets.length) {
        const emitted = this.emitHighlightTargets(action.highlightTargets, ruleId, 'issue', {
          focusTarget: action.focusTarget || action,
          focusSequence: action.focusSequence,
          focusSequenceDelayMs: action.focusSequenceDelayMs
        });
        if (emitted) return;
      }
      this.emitNavigateFromEntity(action.date, action.sequencial, action.plateId, ruleId, 'issue');
    },
    handleLineAction({ line, issue, entity }) {
      const action = line?.action;
      if (!action) return;
      const ruleId = getIssueRule(issue, entity);
      if (Array.isArray(action.highlightTargets) && action.highlightTargets.length) {
        const emitted = this.emitHighlightTargets(action.highlightTargets, ruleId, 'issue', {
          focusTarget: action.focusTarget || action,
          focusSequence: action.focusSequence,
          focusSequenceDelayMs: action.focusSequenceDelayMs
        });
        if (emitted) return;
      }
      const emitted = this.emitHighlightTargets([action], ruleId, 'issue');
      if (emitted) return;
      this.emitNavigateFromEntity(action.date, action.sequencial, action.plateId, ruleId, 'issue');
    },

    // ====== Navegação e destaques ======
    emitHighlightTargets(targets, ruleId, source = 'issue', options = {}) {
      const normalizedTargets = dedupeTargets(targets);
      if (!normalizedTargets.length) return false;

      const normalizedFocusTarget = this.normalizeHighlightTarget(options?.focusTarget)
        || normalizedTargets.find(item => item.sequencial || item.plateId)
        || normalizedTargets[0];
      const normalizedFocusSequence = Array.isArray(options?.focusSequence)
        ? dedupeTargets(options.focusSequence)
        : [];
      const focusSequenceDelayMs = Number.isFinite(Number(options?.focusSequenceDelayMs))
        && Number(options.focusSequenceDelayMs) >= 0
        ? Number(options.focusSequenceDelayMs)
        : 1000;

      const payload = {
        targets: normalizedTargets,
        focusTarget: normalizedFocusTarget,
        ruleId: ruleId || null,
        source
      };
      if (normalizedFocusSequence.length > 1) {
        payload.focusSequence = normalizedFocusSequence;
        payload.focusSequenceDelayMs = focusSequenceDelayMs;
      }
      this.$emit('highlight-request', payload);

      if (this.autoCloseOnNavigate) {
        this.fecharModal();
      }
      return true;
    },
    normalizeHighlightTarget(target) {
      if (!target) return null;
      return buildHighlightTarget(
        target.date,
        target.sequencial,
        target.plateId,
        target.highlightType || 'conflict',
        {
          reasonLabel: target.reasonLabel,
          reasonKey: target.reasonKey,
          origin: target.origin
        }
      );
    },
    emitNavigateFromEntity(date, sequencial, plateId, ruleId, source = 'issue') {
      const normalizedDate = normalizeDateForMenu(date);
      if (!normalizedDate) return;

      this.$emit('navigate-to-menu', {
        date: normalizedDate,
        sequencial: normalizeSequencial(sequencial),
        plateId: plateId ? String(plateId) : null,
        ruleId: ruleId || null,
        source
      });

      if (this.autoCloseOnNavigate) {
        this.fecharModal();
      }
    },
    clearMenuHighlights() {
      this.$emit('clear-highlights-request');
    },
    highlightSolverCells() {
      if (!this.dataCatalog?.tabela) return;
      const targets = [];
      for (const dia of this.dataCatalog.tabela) {
        for (const coluna of (dia.colunas || [])) {
          if (coluna._meta && coluna._meta.id_origem === 'solver') {
            const target = buildHighlightTarget(
              dia.data,
              coluna.id_coluna,
              coluna.id_prato,
              'candidate'
            );
            if (target) targets.push(target);
          } else if (coluna._meta && coluna._meta.id_origem === 'solver_IA') {
            const target = buildHighlightTarget(
              dia.data,
              coluna.id_coluna,
              coluna.id_prato,
              'usage'
            );
            if (target) targets.push(target);
          }
        }
      }
      if (targets.length > 0) {
        this.emitHighlightTargets(targets, null, 'solver');
      }
    },

    // ====== Navegação a partir da aba conformidade ======
    openIssueFromRule(ruleId) {
      const issueData = this.findIssueByRule(ruleId);
      if (!issueData) return;

      const issueKey = getIssueKey(issueData.issue, issueData.issueIndex);
      this.$set(this.expandedIssues, issueKey, true);
      this.$set(this.expandedR2Entities, issueKey, null);
      this.activeTab = 'problemas';

      this.$nextTick(() => {
        this.scrollTabsContentTo(0, 'auto');
        this.refreshModalLayout();
        this.$nextTick(() => {
          this.scrollIssueIntoProblemsTab(issueKey);
        });
      });
    },
    findIssueByRule(ruleId) {
      if (!ruleId || !Array.isArray(this.relatorioData?.issues)) return null;
      const issueIndex = this.relatorioData.issues.findIndex((issue) => {
        if (issue?.ruleReference === ruleId) return true;
        if (!Array.isArray(issue?.affectedEntities)) return false;
        return issue.affectedEntities.some(entity => entity?.rule === ruleId);
      });
      if (issueIndex < 0) return null;
      return { issue: this.relatorioData.issues[issueIndex], issueIndex };
    },
    getTabsContentElement() {
      return this.$el?.querySelector('.tabs-content') || null;
    },
    scrollTabsContentTo(top = 0, behavior = 'auto') {
      const container = this.getTabsContentElement();
      if (!container) return;
      container.scrollTo({ top: Math.max(0, top), behavior });
    },
    scrollIssueIntoProblemsTab(issueKey) {
      const container = this.getTabsContentElement();
      const target = this.$el?.querySelector(`[data-issue-key="${issueKey}"]`);
      if (!container || !target) return;

      const containerRect = container.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const offsetTop = targetRect.top - containerRect.top + container.scrollTop - 12;
      this.scrollTabsContentTo(offsetTop, 'smooth');
    },
    refreshModalLayout() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          window.dispatchEvent(new Event('resize'));
        });
      });
    }
  },
  beforeDestroy() {
    this.$emit('report-loading-change', false);
  }
};
</script>

<style lang="less">
@import (reference) url("../../../assets/variables.less");

.relatorio-modal-wrapper {
  width: calc(100% - 40px);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 85vh;

  .title {
    margin: 0;
    color: #212146;
    font-size: 1.5rem;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .report-status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    padding: 2px 10px;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;

    &.deprecated {
      background: #e3f2fd;
      border: 1px solid #64b5f6;
      color: #1565c0;
    }
  }

  .loading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    min-height: 300px;

    p {
      color: #666;
      font-size: 1.1rem;
    }
  }

  .relatorio-content {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .no-data-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    text-align: center;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    min-height: 300px;

    &.error {
      background: #FFF5F5;
      border-color: #FFCDD2;

      .no-data-icon {
        color: #F44336;
      }
    }
  }

  .no-data-icon {
    font-size: 3rem;
    margin-bottom: 20px;
    color: #2196F3;
  }

  .no-data-content h4 {
    color: #212146;
    margin-bottom: 10px;
    font-size: 1.2rem;
  }

  .no-data-content p {
    color: #666;
    margin-bottom: 25px;
    max-width: 500px;
    line-height: 1.5;
  }

  .tabs {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .tabs-header {
    display: flex;
    background: #f8f9fa;
    border-bottom: 1px solid #e0e0e0;
    flex-shrink: 0;
  }

  .tab-button {
    padding: 12px 24px;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    font-size: 1rem;
    color: #666;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover:not(.active) {
      background: #f0f0f0;
    }

    &.active {
      color: #212146;
      border-bottom-color: #212146;
      font-weight: 600;
      background: white;
    }
  }

  .tabs-content {
    padding: 20px;
    flex: 1;
    overflow-y: auto;
    max-height: calc(85vh - 200px);
  }

  .tab-pane {
    display: flex;
    flex-direction: column;
    gap: 25px;
  }

  .tab-section {
    h4 {
      margin: 0 0 15px 0;
      color: #212146;
      font-size: 1.1rem;
      border-bottom: 2px solid #f0f0f0;
      padding-bottom: 8px;
    }
  }

  .metadata-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 12px;
    background: #f8f9fa;
    padding: 15px;
    border-radius: 6px;
  }

  .metadata-item {
    display: flex;
    flex-direction: column;
  }

  .metadata-label {
    font-size: 0.85rem;
    color: #666;
    font-weight: 500;
    margin-bottom: 2px;
  }

  .metadata-value {
    font-size: 0.95rem;
    color: #212146;
    font-weight: 500;
    word-break: break-word;
  }

  .score-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
    }
  }

  .score-circle {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &.excellent {
      background: linear-gradient(135deg, #4CAF50, #8BC34A);
      color: white;
    }

    &.good {
      background: linear-gradient(135deg, #2196F3, #03A9F4);
      color: white;
    }

    &.regular {
      background: linear-gradient(135deg, #FF9800, #FFC107);
      color: white;
    }

    &.poor {
      background: linear-gradient(135deg, #F44336, #FF5722);
      color: white;
    }
  }

  .score-value {
    font-size: 2.5rem;
    font-weight: bold;
    line-height: 1;
  }

  .score-label {
    font-size: 0.9rem;
    opacity: 0.9;
  }

  .score-details {
    flex: 1;
  }

  .score-before-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    opacity: 0.65;
  }

  .score-label-context {
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: #454545;
    text-transform: uppercase;
  }

  .score-before-subtitle {
    font-size: 0.75rem;
    color: #454545;
  }

  .score-circle-before {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 3px solid #0192d0;
    background: transparent;

    .score-value {
      font-size: 2rem;
      font-weight: 700;
      line-height: 1;
      color: #0192d0;
    }

    .score-label {
      font-size: 0.75rem;
      color: #0192d0;
    }
  }

  .score-arrow-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    color: #4CAF50;
    font-weight: 700;
  }

  .score-arrow {
    font-size: 1.5rem;
  }

  .score-delta {
    font-size: 0.85rem;
    background: rgba(76, 175, 80, 0.15);
    padding: 2px 8px;
    border-radius: 12px;
  }

  .quality-level {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
    flex-wrap: wrap;
  }

  .quality-label {
    font-size: 0.95rem;
    color: #666;
  }

  .quality-value {
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 0.85rem;
    font-weight: 600;

    &.excellent {
      background: #E8F5E9;
      color: #2E7D32;
    }

    &.good {
      background: #E3F2FD;
      color: #1565C0;
    }

    &.regular {
      background: #FFF3E0;
      color: #EF6C00;
    }

    &.poor {
      background: #FFEBEE;
      color: #C62828;
    }
  }

  .summary-text {
    font-size: 1rem;
    color: #555;
    line-height: 1.5;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 6px;
    border-left: 4px solid #212146;
  }

  .issues-summary {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
  }

  .issue-count {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 10px;
    border-radius: 8px;
    text-align: center;

    &.critical {
      background: #FFEBEE;
      border: 1px solid #F44336;
      .issue-count-number { color: #F44336; }
    }

    &.medium {
      background: #FFF1E6;
      border: 1px solid #FB8C00;
      .issue-count-number { color: #EF6C00; }
    }

    &.low {
      background: #FFFDE7;
      border: 1px solid #FBC02D;
      .issue-count-number { color: #F9A825; }
    }
  }

  .issue-count-number {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 5px;

    .critical & {
      color: #F44336;
    }
    .medium & {
      color: #EF6C00;
    }
    .low & {
      color: #F9A825;
    }
  }

  .issue-count-label {
    font-size: 0.9rem;
    font-weight: 600;
    color: #555;
  }

  .detailed-analysis,
  .other-analysis {
    display: flex;
    flex-direction: column;
    gap: 25px;
  }

  .analysis-section,
  .other-section {
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
  }

  .section-header,
  .section-title {
    padding: 15px 20px;
    margin: 0;
    background: #f8f9fa;
    border-bottom: 1px solid #e0e0e0;
    color: #212146;
    font-size: 1rem;
    display: flex;
    align-items: center;
    gap: 10px;

    h4 {
      margin: 0;
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
    }

    i.fa-exclamation-circle {
      color: #F44336;
    }
    i.fa-clipboard-check {
      color: #4CAF50;
    }
    i.fa-lightbulb {
      color: #FF9800;
    }
    i.fa-brain {
      color: #9C27B0;
    }
  }

  .counter-badge {
    background: #212146;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 600;
    margin-left: auto;
  }

  .highlight-legend-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 15px 0 15px;
  }

  .highlight-legend {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }

  .legend-title {
    color: #4b5578;
    font-size: 0.78rem;
    font-weight: 600;
  }

  .legend-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 0.72rem;
    color: #2d3658;
    background: #f4f6fb;
    border: 1px solid #d6deef;

    &::before {
      content: "";
      width: 8px;
      height: 8px;
      border-radius: 50%;
      display: block;
      background: #c62828;
    }

    &.legend-usage::before {
      background: #2e7d32;
    }
    &.legend-candidate::before {
      background: #f9a825;
    }
    &.legend-conflict::before {
      background: #c62828;
    }
  }

  .clear-highlights-btn {
    border: 1px solid #9ca7cd;
    border-radius: 6px;
    background: #f7f9ff;
    color: #2a3357;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 4px 10px;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease;

    &:hover {
      background: #edf2ff;
      border-color: #7f90c6;
    }
  }

  .items-list,
  .other-list {
    padding: 15px;
  }

  .list-item,
  .other-item {
    padding: 12px;
    border-radius: 6px;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    &.critical {
      background: #FFF5F5;
      border: 1px solid #FFCDD2;
      border-left: 3px solid #F44336;
    }

    &.medium {
      background: #FFF1E6;
      border: 1px solid #FFD3A8;
      border-left: 3px solid #FB8C00;
    }

    &.low {
      background: #FFFDE7;
      border: 1px solid #FFE082;
      border-left: 3px solid #FBC02D;
    }

    &.compliant {
      background: #F1F8E9;
      border: 1px solid #C8E6C9;
      border-left: 3px solid #4CAF50;
    }

    &.violated {
      background: #FFF5F5;
      border: 1px solid #FFCDD2;
      border-left: 3px solid #F44336;
    }

    &.partial {
      background: #FFF3E0;
      border: 1px solid #FFECB3;
      border-left: 3px solid #FF9800;
    }
  }

  .item-header {
    display: flex;
    gap: 12px;
    align-items: flex-start;
  }

  .item-icon {
    max-width: 24px;
    max-height: 24px;
    aspect-ratio: 1 / 1;
    border-radius: 50%;
    display: grid;
    place-items: center;
    color: white;
    padding: 4px;

    .critical & {
      background: #F44336;
    }
    .medium & {
      background: #FB8C00;
    }
    .low & {
      background: #FBC02D;
    }
    &.compliant {
      background: #4CAF50;
    }
    &.violated {
      background: #F44336;
    }
    &.partial {
      background: #FF9800;
    }

    i {
      font-size: 12px;
      line-height: 1;
      width: 1em;
      text-align: center;
      display: block;
    }
  }

  .item-content {
    flex: 1;
  }

  .item-title {
    font-weight: 600;
    color: #212146;
    font-size: 0.95rem;
    margin-bottom: 5px;
    line-height: 1.3;
  }

  .item-description {
    color: #666;
    font-size: 0.85rem;
    line-height: 1.4;
  }

  .ignore-issue-btn {
    width: 24px;
    height: 24px;
    border: 2px solid #dc3545;
    border-radius: 50%;
    background: #fff;
    color: #dc3545;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 16px;
    font-weight: bold;
    line-height: 1;

    transition: all 0.2s ease;
  }

  .ignore-issue-btn:hover {
    background: #dc3545;
    color: #fff;
  }

  .ignore-issue-btn:active {
    transform: scale(0.95);
  }

  .issue-accordion-header,
  .rule-accordion-header {
    width: 100%;
    border: none;
    background: transparent;
    padding: 0;
    text-align: left;
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }

  .issue-header-right {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #666;
    font-size: 0.75rem;
    flex-shrink: 0;
  }

  .accordion-chevron {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    min-width: 16px;
    line-height: 1;
    color: #616161;

    i {
      font-size: 12px;
      line-height: 1;
    }
  }

  .entity-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 2px 8px;
    border-radius: 10px;
    background: #eef2ff;
    color: #212146;
    font-size: 0.72rem;
    font-weight: 600;
    white-space: nowrap;
  }

  .issue-accordion-body,
  .rule-accordion-body {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px dashed rgba(33, 33, 70, 0.2);
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .entity-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .entity-card {
    border: 1px solid #dfe3ef;
    border-radius: 8px;
    padding: 10px;
    background: #fff;

    &.entity-card-collapsible {
      padding: 0;
      overflow: hidden;
    }
  }

  .entity-accordion-header {
    width: 100%;
    border: 0;
    background: #f7f9ff;
    color: #1f2446;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    cursor: pointer;
  }

  .entity-accordion-title {
    font-size: 0.82rem;
    font-weight: 700;
    text-align: left;
  }

  .entity-accordion-right {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .entity-card-body {
    padding: 10px;
  }

  .entity-card-toolbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 8px;
  }

  .entity-display {
    display: flex;
  }

  .entity-display.entity-display-r1-frequency,
  .entity-display-r1-frequency {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 12px;
    align-items: center;
    width: 100%;
  }

  .entity-display-r1-frequency > .entity-grid {
    grid-template-columns: repeat(3, minmax(220px, 1fr));
    gap: 10px;
  }

  .entity-display-r1-frequency > .entity-actions {
    margin-top: 0;
    justify-content: flex-end;
    align-items: center;
    align-self: center;
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  .entity-display.entity-display-r3-repetition,
  .entity-display-r3-repetition {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    padding-right: 8px;
    box-sizing: border-box;
  }

  .r3-summary-grid {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
    gap: 10px;
  }

  .r3-tags-actions-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    column-gap: 10px;
    row-gap: 8px;
    align-items: center;
    width: 100%;
  }

  .r3-tags-row {
    margin-top: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    min-width: 0;
  }

  .r3-actions-row {
    display: flex;
    margin-top: 0;
    justify-content: flex-end;
    align-items: center;
    align-self: center;
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  .entity-display.entity-display-r8-unmet,
  .entity-display-r8-unmet {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas:
      "grid grid"
      "tags actions"
      "lines lines";
    column-gap: 10px;
    row-gap: 8px;
    align-items: start;
    width: 100%;
  }

  .entity-display-r8-unmet > .entity-grid {
    grid-area: grid;
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }

  .entity-display-r8-unmet > .entity-tags {
    grid-area: tags;
    margin-top: 0;
  }

  .entity-display-r8-unmet > .entity-actions {
    grid-area: actions;
    margin-top: 0;
    justify-content: flex-end;
    align-self: start;
  }

  .entity-display-r8-unmet > .entity-lines {
    grid-area: lines;
    margin-top: 0;
  }

  .entity-display.entity-display-r10-gap,
  .entity-display-r10-gap {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas:
      "grid grid"
      "tags actions";
    column-gap: 10px;
    row-gap: 8px;
    align-items: start;
    width: 100%;
  }

  .entity-display-r10-gap > .entity-grid {
    grid-area: grid;
    grid-template-columns: repeat(3, minmax(190px, 1fr));
    gap: 10px;
  }

  .entity-display-r10-gap > .entity-tags {
    grid-area: tags;
    margin-top: 0;
  }

  .entity-display-r10-gap > .entity-actions {
    grid-area: actions;
    margin-top: 0;
    justify-content: flex-end;
    align-items: flex-start;
    align-self: start;
    flex-wrap: nowrap;
    white-space: nowrap;
  }

  .entity-display.entity-display-r9-conflict,
  .entity-display-r9-conflict {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    row-gap: 8px;
    width: 100%;
  }

  .entity-display.entity-display-r11-cost,
  .entity-display-r11-cost {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    row-gap: 8px;
    width: 100%;
  }

  .entity-display-r11-cost > .entity-grid {
    grid-template-columns: repeat(2, minmax(190px, 1fr));
    gap: 10px;
  }

  .r11-plate-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr)) auto;
    gap: 12px;
    align-items: center;
    width: 100%;
  }

  .r11-plate-item {
    justify-content: flex-start !important;
  }

  .r11-plate-item strong {
    margin-right: 0;
  }

  .r11-plate-value {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.85rem;
    color: #1f2446;
    font-weight: 600;
  }

  .r11-plate-action {
    justify-self: end;
    white-space: nowrap;
  }

  .entity-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
    gap: 8px;
    width: 100%;
  }

  .entity-line {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    font-size: 0.8rem;
    color: #333;
    background: #f9fafc;
    border-radius: 6px;
    padding: 6px 8px;

    &.entity-line-entity,
    &.entity-line-usage {
      flex-wrap: wrap;
    }

    &.entity-line-single-line {
      flex-wrap: nowrap;
      min-width: 0;
    }

    &.entity-line-single-line strong {
      flex: 0 0 auto;
    }

    &.entity-line-group-usage {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 6px;
    }

    &.entity-line-r9-summary,
    &.entity-line-r9-details,
    &.entity-line-r5-details,
    &.entity-line-r4-details,
    &.entity-line-r11-plate {
      background: transparent;
      border-radius: 0;
      padding: 0;
      display: block;
    }
  }

  .entity-value-entity {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;

    &.entity-value-entity-single-line {
      flex: 1 1 auto;
      flex-wrap: nowrap;
      min-width: 0;
      overflow: hidden;
    }
  }

  .entity-code-chip {
    font-size: 0.75rem;
    color: #4a5278;
    background: #e9edf8;
    border: 1px solid #d7dff2;
    border-radius: 10px;
    padding: 2px 8px;
    font-weight: 600;
  }

  .entity-value-name {
    font-size: 0.85rem;
    color: #1f2446;
    font-weight: 600;

    &.entity-value-name-single-line {
      flex: 1 1 auto;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .entity-text-value-single-line {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .entity-usage-metrics {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }

  .r5-details-layout {
    width: 100%;
    background: #fff;
    border: 1px solid #dfe3ef;
    border-radius: 8px;
    padding: 10px;
  }

  .r5-details-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr)) auto;
    gap: 12px;
    align-items: center;
    width: 100%;
  }

  .r5-detail-item {
    justify-content: flex-start !important;
  }

  .r5-detail-item strong {
    margin-right: 0;
  }

  .r5-detail-value {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.85rem;
    color: #1f2446;
    font-weight: 600;
  }

  .r5-details-action {
    justify-self: end;
    white-space: nowrap;
  }

  .r9-summary-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    width: 100%;
  }

  .r9-details-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
    gap: 12px;
    align-items: center;
    width: 100%;
  }

  .r4-details-grid {
    display: grid;
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr) minmax(0, 1.1fr) auto;
    gap: 12px;
    align-items: center;
    width: 100%;
  }

  .r9-summary-item,
  .r9-detail-item,
  .r4-detail-item,
  .r11-plate-item {
    justify-content: flex-start !important;
  }

  .r9-summary-item strong,
  .r9-detail-item strong,
  .r4-detail-item strong,
  .r11-plate-item strong {
    margin-right: 0;
  }

  .r4-detail-value {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.85rem;
    color: #1f2446;
    font-weight: 600;
  }

  .r9-details-action,
  .r4-details-action {
    justify-self: end;
    white-space: nowrap;
  }

  .r3-group-entities,
  .r8-group-entities {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .r3-entity-card {
    background: #fff;
  }

  .group-usage-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    flex-wrap: wrap;
  }

  .group-name {
    font-size: 0.85rem;
    color: #1f2446;
    font-weight: 600;
  }

  .group-usage-metrics {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }

  .group-usage-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .group-usage-scope {
    font-size: 0.75rem;
    color: #42507b;
    background: #edf2ff;
    border: 1px solid #d7e2ff;
    border-radius: 10px;
    padding: 2px 8px;
    font-weight: 500;
  }

  .group-usage-chip {
    font-size: 0.75rem;
    color: #3c4665;
    background: #f3f5fa;
    border: 1px solid #dde2ee;
    border-radius: 10px;
    padding: 2px 8px;
  }

  .entity-lines {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .entity-tags {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .entity-tag {
    background: #f2f5fb;
    color: #3b3f62;
    border: 1px solid #d5dbef;
    border-radius: 14px;
    padding: 3px 8px;
    font-size: 0.75rem;

    &.entity-tag-action {
      cursor: pointer;
      transition: background 0.2s ease, border-color 0.2s ease;
      font-family: inherit;

      &:hover {
        background: #e6ecfa;
        border-color: #becae8;
      }
    }
  }

  .entity-actions {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .navigate-btn {
    border: 1px solid #212146;
    border-radius: 6px;
    background: #212146;
    color: white;
    font-size: 0.75rem;
    padding: 4px 8px;
    cursor: pointer;
    transition: background 0.2s ease;
    white-space: nowrap;

    &:hover {
      background: #171736;
    }

    &.navigate-btn-usage {
      background: #2e7d32;
      border-color: #2e7d32;

      &:hover {
        background: #276c2b;
      }
    }

    &.navigate-btn-candidate {
      background: #f9a825;
      border-color: #f9a825;
      color: #1f2446;

      &:hover {
        background: #e29a20;
      }
    }

    &.navigate-btn-conflict {
      background: #c62828;
      border-color: #c62828;

      &:hover {
        background: #a92222;
      }
    }
  }

  .entity-fallback {
    font-size: 0.8rem;
    color: #555;

    pre {
      margin: 8px 0 0 0;
      white-space: pre-wrap;
      max-height: 220px;
      overflow: auto;
      background: #f8f9fb;
      border: 1px solid #e1e5f0;
      border-radius: 6px;
      padding: 8px;
    }
  }

  .entity-empty {
    font-size: 0.85rem;
    color: #666;
    background: #f9fafc;
    border: 1px dashed #d2d9ea;
    border-radius: 6px;
    padding: 10px;
  }

  .recommendation-item {
    background: #FFF3E0;
    border-left: 3px solid #FF9800;
  }

  .recommendation-priority {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 0.75rem;
    font-weight: 600;
    margin-bottom: 8px;

    &.high {
      background: #FFEBEE;
      color: #C62828;
    }
    &.medium {
      background: #FFF3E0;
      color: #EF6C00;
    }
    &.low {
      background: #E8F5E9;
      color: #2E7D32;
    }
  }

  .recommendation-text {
    color: #212146;
    font-size: 0.9rem;
    line-height: 1.4;
    margin: 8px 0;
  }

  .signal-item {
    background: #F3E5F5;
    border-left: 3px solid #9C27B0;
  }

  .signal-header {
    margin-bottom: 8px;
  }

  .signal-type {
    font-weight: 600;
    color: #212146;
    font-size: 0.9rem;
  }

  .signal-description {
    color: #212146;
    font-size: 0.85rem;
    line-height: 1.4;
    margin: 8px 0;
  }

  .no-data-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    color: #888;
    text-align: center;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px dashed #e0e0e0;

    i {
      font-size: 3rem;
      margin-bottom: 15px;
      color: #4CAF50;
    }

    p {
      font-size: 1rem;
      color: #666;
      margin: 0;
    }
  }

  .modal-buttons {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
    flex-shrink: 0;
    padding-top: 20px;
    border-top: 1px solid #e7e7e7;
  }

  .modal-buttons-row {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    flex-wrap: wrap;
    width: 100%;
  }

  .cardapio-error-message {
    color: #dc143c;
    font-size: 0.85rem;
    margin: 0;
    text-align: right;
  }

  .button {
    padding: 8px 16px;
    border-radius: 4px;
    font-weight: 500;
    cursor: pointer;
    border: 1px solid transparent;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    &.ghost {
      background: white;
      color: #dc143d;
      border: 1px solid #dc143d;

      &:hover:not(:disabled) {
        background: #f8f8f8;
      }
    }

    &.primary {
      background: #212146;
      color: white;

      &:hover:not(:disabled) {
        background: #1a1a38;
      }
    }
  }

  .relatorio-sync-icon-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1em;
    height: 1em;
    transform-origin: center;
    will-change: transform;

    &.is-spinning {
      animation: relatorio-sync-spin 1s linear infinite !important;
    }
  }

  .relatorio-sync-icon {
    display: inline-block;
    transform-origin: center;
  }

  @keyframes relatorio-sync-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  @media (max-width: 768px) {
    .relatorio-modal-wrapper {
      padding: 15px;
      max-height: 90vh;
    }

    .tabs-content {
      padding: 15px;
      max-height: calc(90vh - 180px);
    }

    .modal-buttons {
      flex-direction: column;

      .button {
        width: 100%;
        justify-content: center;
      }
    }

    .score-container {
      flex-direction: column;
      text-align: center;
    }

    .quality-level {
      flex-direction: column;
      align-items: center;
      gap: 5px;
    }

    .issues-summary {
      grid-template-columns: 1fr;
    }

    .entity-display-r8-unmet {
      grid-template-columns: 1fr;
      grid-template-areas:
        "grid"
        "tags"
        "actions"
        "lines";
    }
    .entity-display-r8-unmet > .entity-grid {
      grid-template-columns: 1fr;
    }
    .entity-display-r8-unmet > .entity-actions {
      justify-content: flex-start;
    }

    .entity-display-r1-frequency {
      grid-template-columns: 1fr;
    }
    .entity-display-r1-frequency > .entity-grid {
      grid-template-columns: 1fr;
    }
    .entity-display-r1-frequency > .entity-actions {
      justify-content: flex-start;
    }

    .entity-display-r10-gap {
      grid-template-columns: 1fr;
      grid-template-areas:
        "grid"
        "tags"
        "actions";
    }
    .entity-display-r10-gap > .entity-grid {
      grid-template-columns: 1fr;
    }
    .entity-display-r10-gap > .entity-actions {
      justify-content: flex-start;
    }

    .entity-display-r3-repetition {
      grid-template-columns: 1fr;
    }
    .r3-summary-grid {
      grid-template-columns: 1fr;
    }
    .r3-tags-actions-row {
      grid-template-columns: 1fr;
    }
    .r3-actions-row {
      justify-content: flex-start;
    }

    .entity-display-r10-gap {
      grid-template-columns: 1fr;
    }
    .entity-display-r10-gap > .entity-grid {
      grid-template-columns: 1fr;
    }
    .entity-display-r10-gap > .entity-actions {
      justify-content: flex-start;
    }

    .r5-details-grid,
    .r9-summary-grid,
    .r9-details-grid,
    .r4-details-grid,
    .r11-plate-grid {
      grid-template-columns: minmax(0, 1fr);
    }
    .r5-details-action,
    .r9-details-action,
    .r4-details-action,
    .r11-plate-action {
      justify-self: flex-start;
    }
  }

  @media (max-width: 480px) {
    .tabs-header {
      flex-direction: column;

      .tab-button {
        width: 100%;
        text-align: center;
      }
    }

    .metadata-container {
      grid-template-columns: 1fr;
    }
  }
}
</style>